import Vue from 'vue';
import { Swipe, SwipeItem , Checkbox, CheckboxGroup , DatetimePicker , Button, Field , NumberKeyboard , Popup , Loading , Icon , Toast , ImagePreview , Uploader,  CellGroup, Cell, Radio, RadioGroup , Cascader , Tab, Tabs , PullRefresh , List , Image as VanImage , Skeleton , Card , Dialog , Overlay } from 'vant';
import App from './App.vue';
import store from './store';
import router from './router';
import '../style.css';

// 提前加载 yolo1 面诊/舌诊模型（MediaPipe 人脸检测 + ONNX 分类）
// 应用启动时即开始后台加载，用户进入相机页面时模型大概率已就绪
import { loadDetector as preloadFaceDetector } from '@/utils/faceDetector';
import { initDetector as preloadTongueDetector } from '@/utils/tongueDetector';
if (typeof window !== 'undefined' && window.readLocalModel) {
  preloadFaceDetector();
  preloadTongueDetector();
}

Vue.config.productionTip = false;

Vue.directive("dome",{
    inserted(el,binding){
        const callback = binding.value;
        window.addEventListener("resize",()=>{
            return callback(window.innerWidth);
        });
        el._onResize = callback;
    },
    unbind(el){
        if(el._onResize) return;
        window.removeEventListener("resize",el.removeEventListener);
        delete el._onResize;
    }
});

Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Button);
Vue.use(Field);
Vue.use(NumberKeyboard);
Vue.use(ImagePreview);
Vue.use(Popup);
Vue.use(Loading);
Vue.use(Icon);
Vue.use(Toast);
Vue.use(DatetimePicker);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Uploader);
Vue.use(CellGroup);
Vue.use(Cell);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Cascader);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(PullRefresh);
Vue.use(List);
Vue.use(VanImage);
Vue.use(Skeleton);
Vue.use(Card);
Vue.use(Dialog);
Vue.use(Overlay);

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
